import { asyncAction } from 'lib/actions';

export const fetchLotsAppendPageAction = asyncAction('saleLotsListPage/APPEND_LOTS_LIST');
export const fetchLotsAction = asyncAction('saleLotsListPage/FETCH_LOTS_LIST');
